import React from 'react';
import { Box } from '@mui/material';
import { Container } from 'components';
import Footer from './Footer';
import Header from './Header';

const Layout: React.FC = (props) => {
  const { children } = props;

  return (
    <Container bgcolor="#eff1f5" margin="none" width="100%">
      <Box
        position="sticky"
        top="0"
        width={1}
        zIndex={400}
        bgcolor="#fff"
        boxShadow="0 0 0 1px #eff1f5"
      >
        <Container>
          <Header />
        </Container>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        minHeight="calc(100vh - 56px)"
        // ml="56px"
      >
        {children}
        <Footer />
      </Box>
    </Container>
  );
};

export default Layout;
